<app-loader *ngIf="isLoading">{{ isLoading }}</app-loader>
<div class="page-bar">
    <ul class="page-breadcrumb">
        <li class="breadcrumb-li">
            <i class="fa fa-home breadcrumb-a"></i>
            <a routerLink="/home" class="breadcrumb-a">Home</a>
        </li>
        <li class="breadcrumb-li breadcrumb-a">
            <i class="fa fa-angle-right breadcrumb-a"></i>
            <a class="currentPage" routerLink="/allprofsummary">All Profiles Summary</a>
        </li>
    </ul>
</div>
<div class="inner-content">
    <div class="card">
        <div class="cord-body">
            <div class="row">
                <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                        <input matInput [formControl]="minDate" readonly="true" [matDatepicker]="fromPicker"
                            placeholder="Choose a date">
                        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                        <mat-datepicker #fromPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                        <input matInput [formControl]="maxDate" readonly="true" [matDatepicker]="toPicker"
                            placeholder="Choose a date">
                        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                        <mat-datepicker #toPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="example-full-width boder-none">
                        <mat-label>Search</mat-label>
                        <textarea matInput [(ngModel)]="quickFilter" placeholder="Search with Client, Assessment, Candidate..."></textarea>
                      </mat-form-field>                    
                </div>
                <div class="col-md-3">
                    <button type="submit" class="btn-success mr-5" (click)="getProfilesSummary()">Search</button>
                </div>
                <div class="col-md-3 align-right" *ngIf="allAssessmentData?.length">
                    <a class="excel-download-btn" (click)="exportAsExcelFile(allAssessmentData,'All_Profiles')"
                        target="_self" download>
                        <i _ngcontent-fnt-c50="" class="fa fa-file-excel-o blue"></i> </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="inner-content" *ngIf="allAssessmentData?.length">
    <table class="table table-hover">
        <thead class="bordered-darkorange">
            <tr>
                <th>User Id</th>
                <th>User Name</th>
                <th>Email</th>
                <th>Contact No</th>
                <th>Password</th>
                <th>Assessment Name</th>
                <th>Assessment Created Dt</th>
                <th>Assessment End Dt</th>
                <th>Assessment Status</th>
                <th>Total Score</th>
                <th>Total Questions</th>
                <th class="text-right">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let assessment of allAssessmentData">
                <td>{{assessment.UserId}}</td>
                <td>{{assessment.UserName}}</td>
                <td>{{assessment.EmailId}}</td>
                <td>{{assessment.MobileNo}}</td>
                <td>{{assessment.Password}}</td>
                <td>{{assessment.AssessmentName}} </td>
                <td>{{assessment.AssessmentCreatedDate | date}}</td>
                <td>{{assessment.AssessmentCompletedDate}}</td>
                <td>{{ replaceStatusByName(assessment.UserAssessmentStatusId)}}</td>
                <td>{{assessment.TotalScore}}</td>
                <td>{{assessment.TotalQuestions}}</td>
                <td class="text-right addCandidate">
                    <a title="Download Report" (click)="downloadAsPDF(assessment.UserAssessmentId)" class="grid-anchor">
                        <i *ngIf="assessment.UserAssessmentStatusId?.toString() === userAssessmentStatus.Complete || assessment.UserAssessmentStatusId?.toString() === userAssessmentStatus.TimeOut"
                            class="far fa-file-pdf editIcon"></i>
                    </a>
                    <a title="View Recording" (click)="getProctorResults(assessment.UserAssessmentId)"
                        class="grid-anchor ">
                        <i *ngIf="assessment.UserAssessmentStatusId?.toString() === userAssessmentStatus.Complete || assessment.UserAssessmentStatusId?.toString() === userAssessmentStatus.TimeOut"
                            class="fa fa-video-camera editIcon"></i>
                    </a>
                    <a title="View Results" routerLink="/userass/results/{{assessment.UserAssessmentId}}"
                        class="grid-anchor"
                        *ngIf="assessment.UserAssessmentStatusId?.toString() === userAssessmentStatus.Complete || assessment.UserAssessmentStatusId?.toString() === userAssessmentStatus.TimeOut">
                        <i class="far fa-list-alt editIcon"></i>
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
</div>